import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import RouteCollection from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import { BtnAnimationSheen } from '../../helpers/UIElements';

import PageWrapper from '../../components/PageWrapper';
import MenuAbout from '../../components/MenuAbout';
import InsideHeader from '../../components/InsideHeader';
import Blogcard from '../../components/BlogCard';
import { colors } from '../../styles';

const styles = css`
  padding: 70px 0;
  @media(min-width: 992px) {
    padding: 120px 0;
  }
  .BlogpostsMore_btnWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 0;
    @media(min-width: 992px) {
      padding: 45px 0;
    }
  }
  .BlogpostsMore_btn {
    height: 45px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    cursor: pointer;
    @media(min-width: 992px) {
      height: 55px;
      padding: 0 35px;
      font-size: 17px;
      letter-spacing: 0;
    }
    &:focus {
      outline: none;
    }
  }
`;

const Increment = 6;
class Blogposts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: Increment,
    };
  }
  showMore = () => {
    this.setState({ limit: this.state.limit + Increment });
  }
  render() {
    const { limit } = this.state;
    const { blogposts, page, router } = this.props;

    const route = RouteCollection.getRouteByPath(get(router, 'location.pathname'));
    let routeParam = '';
    if (get(route, 'params.blogCategory')) {
      routeParam = get(route, 'params.blogCategory').replace(/-/g, ' ');
    }
    const metaTitle = get(route, 'params.blogCategory') ? routeParam : get(page, 'meta.name');
    const showMoreNumber = (limit + Increment) > blogposts.length
    ? blogposts.length - limit : `in ${Increment}`;
    return (
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={metaTitle}
          background={get(page, 'page_image')}
        />
        <MenuAbout />
        <div className={styles}>
          <div className="container">
            <div className="d-flex flex-wrap justify-content-center">
              {
                orderBy(blogposts, 'date', 'desc').slice(0, limit).map(item => (
                  <Blogcard blogpost={item} key={item._id} />
                ))
              }
            </div>
            {
              limit < blogposts.length &&
              <div className="BlogpostsMore_btnWrapper">
                <BtnAnimationSheen className="BlogpostsMore_btn mt-3" onClick={this.showMore} role="button" tabIndex={0}>View The Next {showMoreNumber} {(blogposts.length - limit) === 1 ? 'Post' : 'Posts'}</BtnAnimationSheen>
              </div>
            }
          </div>
        </div>
      </PageWrapper>
    );
  }
}

Blogposts.propTypes = {
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData(
  {
    blogposts: true,
    page: 'blogposts',
    router: true,
  },
  {
    ifMissing404: true,
  },
)(Blogposts);



// WEBPACK FOOTER //
// ./src/pages/Blogposts/index.js